import { PBRBaseMaterial } from '@babylonjs/core';

class MaterialStore {
  public store: Array<{ key: string, material: PBRBaseMaterial }> = [];
  public counter: number = 0;

  public getMaterial(key: string) {
    for (let i = 0; i < this.store.length; ++i) {
      if (this.store[i].key === key) {
        return this.store[i].material.clone(key);
      }
    }
    return null;
  }

  public addMaterial(key: string, material: PBRBaseMaterial) {
    this.store.push({ key, material });
    return material.clone(key);
  }
}

const materialStore = new MaterialStore();
export default materialStore;
